import { BigNumber } from "ethers";

export interface NetworkInfo {
  name: NetworkName;
  chainId: ChainId;
}
export enum ChainId {
  ETH = 1,
  BSC = 56,
  FTM = 250,
  BRISE = 32520,
  XDC = 50,
  WAN = 888,
  TELOS = 40,
  OKC = 66,
  CORE = 1116,
  SHARDEUM = 8081,
}
export enum NetworkName {
  ETH = "ETHEREUM",
  BSC = "BSC",
  FTM = "FANTOM",
  BITGERT = "BITGERT",
  XDC = "XDC",
  WAN = "WANCHAIN",
  TELOS = "TELOSCHAIN",
  OKC = "OKC",
  CORE = "CORE",
  SHARDEUM = "SHARDEUM",
}

export enum BridgeName {
  Stargate = "stargate",
  Multichain = "multichain_v6",
  IceBridge = "ice",
}
export enum SwapTypes {
  Regular = 1,
  StargateBridge = 2,
}
export interface BitgertRouteResponseDto {
  bitgert: Array<VolumeSpilitedRouteRoutes>;
  bridge: Array<VolumeSpilitedRouteRoutes>;
}
export interface RouteResponseDto {
  input_amount: number;
  input_amount_wei: number;
  price_impact: number;
  return_amount: number;
  return_amount_wei: string;
  routes: BitgertRouteResponseDto;
}

export interface OneChainSwapRoutes {
  srcToken: string;
  dstToken: string;
  srcAmount: string;
  dstMinAmount: string;
  swapType: number;
  protocolType: number;
  path: Array<string>;
  protocolAddresses: Array<string>;
}
export interface OneChainSwapDescriptionStruct {
  srcToken: string;
  dstToken: string;
  srcDesiredAmount: string;
  dstDesiredMinAmount: string;
  to: string;
  dstChainId: number;
  dstPoolId: number;
  srcPoolId: number;
  gasForSwap: BigNumber;
  dstContractAddress: string;
  isRegularTransfer: boolean;
  routes: Array<OneChainSwapRoutes>;
}
export interface MultiChainSwapRoutes {
  srcToken: string;
  dstToken: string;
  srcAmount: string;
  dstMinAmount: string;
  swapType: number;
  protocolType: number;
  path: Array<string>;
  protocolAddresses: Array<string>;
}
export interface MultiChainSwapDescriptionStruct {
  srcToken: string;
  dstToken: string;
  srcDesiredAmount: string;
  dstDesiredMinAmount: string;
  to: string;
  dstChainId: number;
  dstPoolId: number;
  srcPoolId: number;
  gasForSwap: BigNumber;
  dstContractAddress: string;
  isRegularTransfer: boolean;
  routes: Array<MultiChainSwapRoutes>;
}
export interface RouteRoutes {
  input_amount: number;
  input_amount_wei: number;
  operations: Array<RouteRegularOperations | RouteStargateBridgeOperations>;
  operations_seperated: Array<RouteOperationsSeparated>;
  return_amount: number;
  return_amount_wei: string;
}
export interface VolumeSpilitedRouteRoutes {
  gas_fee_in_usd: number;
  input_amount: number;
  input_amount_in_usd: number;
  input_amount_wei: number;
  price_impact: number;
  return_amount: number;
  return_amount_in_usd: number;
  return_amount_wei: string;
  routes: Array<RouteRoutes>;
}
export interface RouteOperationsSeparated {
  chain: NetworkName;
  chain_id?: number;
  gas_fee?: number;
  operations: Array<RouteRegularOperations | RouteStargateBridgeOperations>;
}
export class RouteRegularOperations {
  constructor(partial: Partial<RouteRegularOperations> = {}) {
    Object.assign(this, partial);
  }
  amount_in: number;
  amount_in_wei: string;
  amount_out: number;
  amount_out_wei: string;
  ask_token: Array<string>;
  contract_addr: string;
  exchange: BridgeName & string;
  offer_token: Array<string>;
  router_addr: string;
}
export class RouteStargateBridgeOperations {
  constructor(partial: Partial<RouteStargateBridgeOperations> = {}) {
    Object.assign(this, partial);
  }
  amount_in: number;
  amount_in_wei: string;
  amount_out: number;
  amount_out_wei: string;
  ask_bridge_data: { chain_id: number; pool_id: number };
  ask_token: Array<string>;
  contract_addr: string;
  exchange: BridgeName;
  offer_bridge_data: { chain_id: number; pool_id: number };
  offer_token: Array<string>;
  router_addr: string;
}
